module.exports = __webpack_public_path__ + "img/img1.71bd5de7.jpg";